module.exports = __webpack_public_path__ + "static/media/ENCONTRO_2_ED_FISICA.2e3baf70.pdf";